module.exports = __webpack_public_path__ + "/img/Plcc-Custom-Footprint-Q1l4vY.svg";